import type { Components, Theme } from '@mui/material/styles';
import { BUTTON_SIZE_TYPOGRAPHY } from '../typography/buttonSizes';

export const MUI_BUTTON_COMPONENTS: Pick<Components<Theme>, 'MuiButton'> = {
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        borderRadius: theme.radius.sm,
      }),
      sizeLarge: BUTTON_SIZE_TYPOGRAPHY.large,
      sizeMedium: BUTTON_SIZE_TYPOGRAPHY.medium,
      sizeSmall: BUTTON_SIZE_TYPOGRAPHY.small,
    },
    variants: [
      {
        props: { size: 'extraSmall' },
        style: BUTTON_SIZE_TYPOGRAPHY.extraSmall,
      },
    ],
  },
};
